// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"1568":"components.tooltip","2009":"components.tooltipv3","5070":"Betslip","7962":"home"}[chunkId] + "." + {"1568":"f8955af3","2009":"1f3cb6c8","5070":"d3fe0428","7962":"f06f68d6"}[chunkId] + ".css";
};